export function pickGiphyBestUrl(item) {
  const images = item?.images || {};
  return (
    images?.fixed_width?.url ||
    images?.downsized?.url ||
    images?.original?.url ||
    ""
  );
}

export async function giphyFetch({ key, endpoint = "trending", params = {}, signal }) {
  const url = new URL(`https://api.giphy.com/v1/gifs/${endpoint}`);
  url.searchParams.set("api_key", key);
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, String(v));
  });
  const res = await fetch(url.toString(), { signal });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`GIPHY ${res.status}: ${txt || res.statusText}`);
  }
  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}
